webpackJsonp([216004592871862],{

/***/ 280:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	exports.default = Template;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _graphql = __webpack_require__(8);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	var _gatsbyLink = __webpack_require__(30);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// find a post title by path
	var findNode = function findNode(path, data) {
	  return data.allMarkdownRemark.edges.map(function (edge) {
	    return edge.node.frontmatter;
	  }).filter(function (r) {
	    return r.path === path;
	  }).pop();
	};
	
	function Template(_ref) {
	  var data = _ref.data;
	  var post = data.markdownRemark;
	
	  var related = post.frontmatter.related ? post.frontmatter.related.map(function (r) {
	    return findNode(r.post, data);
	  }) : [];
	  return _react2.default.createElement(
	    'article',
	    { className: 'blog-article' },
	    _react2.default.createElement(
	      'h1',
	      { className: 'blog-title is-size-3' },
	      'Introduction to Gatsby'
	    ),
	    _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: post.html } }),
	    post.frontmatter.related && _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'h4',
	        null,
	        'Related'
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        related.map(function (r, i) {
	          return _react2.default.createElement(
	            'article',
	            { key: i, className: 'blog-card' },
	            _react2.default.createElement(
	              'a',
	              { href: '/blog/2017-05-31-introduction-to-gatsby/' },
	              _react2.default.createElement(
	                'h2',
	                null,
	                'Introduction to Gatsby'
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'blog-card-summary' },
	                'In case you haven\u2019t heard about it, Gatsby is the latest hot thing in static site generators'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'css-12lx5dg' },
	              _react2.default.createElement(
	                'div',
	                { className: 'gatsby-image-outer-wrapper', style: { position: 'relative' } },
	                _react2.default.createElement(
	                  'div',
	                  {
	                    className: 'css-h0bc48 gatsby-image-wrapper',
	                    style: { position: 'relative', overflow: 'hidden', display: 'inline-block', width: 30, height: 30 } },
	                  _react2.default.createElement('img', {
	                    alt: true,
	                    width: 30,
	                    height: 30,
	                    src: '/static/michelle-barker-0b8a1fc61532e5bdd544b3b126f0376a-03a46.jpg',
	                    style: {
	                      position: 'absolute',
	                      top: 0,
	                      left: 0,
	                      transition: 'opacity 0.5s',
	                      width: '100%',
	                      height: '100%',
	                      objectFit: 'cover',
	                      objectPosition: 'center center',
	                      opacity: 1
	                    }
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'css-1x81eig' },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { className: 'css-id30rn', href: '/contributors/michelle-barker/' },
	                    'Michelle Barker'
	                  ),
	                  ' ',
	                  'on May 31st 2018'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: r.path },
	              r.title
	            )
	          );
	        })
	      )
	    )
	  );
	}
	
	Template.propTypes = {
	  data: _propTypes2.default.object
	};
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-template-blog-post-js-3912ef05f5d241bf2fd1.js